/*
 * Paired asset for snippets/variant-highlights.liquid.
 *
 * Keeps the highlight row in step with the variant picker.
 *
 * The vendor `product-info.js` does not re-render the product information block
 * wholesale on a variant change. It fetches the section for the new variant and
 * then copies a fixed list of element ids out of it - price, Sku, Inventory,
 * Badges and a handful more - leaving everything else as first rendered. Adding
 * an id to that list means editing a vendor file, so this subscribes to the same
 * `variantChange` event instead and performs the same swap for its own element,
 * the way `money-format.js` replaces a vendor function rather than editing it.
 *
 * The event carries the already-parsed section HTML, so there is no second
 * request: the work here is finding the matching element in it and moving the
 * markup across.
 */
(() => {
  const SELECTOR = '[id^="VariantHighlights-"]';

  const subscribe = () => {
    if (!window.FoxTheme?.pubsub?.subscribe || !window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.variantChange) {
      return false;
    }

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
      const { sectionId, html } = event?.data || {};
      if (!sectionId || !html) return;

      const source = html.getElementById(`VariantHighlights-${sectionId}`);
      if (!source) return;

      /*
       * `sectionId` is the section's own id, while the element rendered on the
       * page carries whatever id the block was rendered with. On the product
       * page they are the same; in a quick view they are not, so every instance
       * whose suffix matches is updated and any other is left alone.
       */
      document.querySelectorAll(SELECTOR).forEach((destination) => {
        if (destination.id !== `VariantHighlights-${sectionId}`) return;
        destination.innerHTML = source.innerHTML;
      });
    });

    return true;
  };

  /*
   * theme.js is deferred and defines FoxTheme, and this file is deferred too, so
   * ordering is by document position rather than guaranteed. Falling back to
   * DOMContentLoaded covers the case where this runs first.
   */
  if (!subscribe()) {
    document.addEventListener('DOMContentLoaded', subscribe, { once: true });
  }
})();
